import { useState } from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';


const messages = defineMessages({
    labelNav: {
        id: 'Minisite navigation',
        defaultMessage: 'Minisite navigation',
    },
    closeMobileMenu: {
        id: 'Close menu',
        defaultMessage: 'Close menu',
    },
    openMobileMenu: {
        id: 'Open menu',
        defaultMessage: 'Open menu',
    },
});


const NavigationMinisite = () => {
    const intl = useIntl();
    const navigation = useSelector((state) => state.navroot.data?.custom_root?.navigation);

    /* Controls mobile menu state */
    const [isMobileMinisiteMenuOpen, setisMobileMinisiteMenuOpen] = useState(false);
    const toggleMobileMinisiteMenu = () => {
        setisMobileMinisiteMenuOpen(!isMobileMinisiteMenuOpen);
    };
    const closeMobileMinisiteMenu = () => {
        if (!isMobileMinisiteMenuOpen) {
            return;
        }
        setisMobileMinisiteMenuOpen(false);
    };

    return (
        navigation.length > 0 && (
            <>
                <button className={'navMinisiteToggle d-print-none mobile tablet only ' + (isMobileMinisiteMenuOpen && 'is-active')}
                    type="button"
                    onClick={toggleMobileMinisiteMenu}
                    aria-expanded={isMobileMinisiteMenuOpen}
                    aria-controls="minisite-nav" >
                    {isMobileMinisiteMenuOpen ? (
                        <>
                            <FontAwesomeIcon icon={faXmark} />
                            <span className="visually-hidden">{intl.formatMessage(messages.closeMobileMenu)}</span>
                        </>
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faBars} />
                            <span className="visually-hidden">{intl.formatMessage(messages.openMobileMenu)}</span>
                        </>
                    )}
                </button>
                <nav id="minisite-nav" className={"minisiteNav d-print-none "  + (isMobileMinisiteMenuOpen && 'open')} aria-label={intl.formatMessage(messages.labelNav)}>
                    <ul className="minisiteNav__list list-unstyled " onClick={closeMobileMinisiteMenu}>
                        {navigation.map((item) => (
                            <li className="minisiteNav__item" key={item['@id']}>
                                <UniversalLink href={flattenToAppURL(item.getRemoteUrl || item['@id'])} className="minisiteNav__link">{item.title}</UniversalLink>
                            </li>
                        ))}
                    </ul>
                </nav>

            </>
        )
    )
};

export default NavigationMinisite;